import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrowhead-g",
  "use": "app-icon-arrowhead-g-usage",
  "viewBox": "0 0 23 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 20\" id=\"app-icon-arrowhead-g\"><path d=\"M14.287.469l.127.117 8 8a2 2 0 01.117 2.701l-.117.127-8 8a2 2 0 01-2.945-2.701l.117-.127L16.17 12H2a2 2 0 01-.15-3.995L2 8h14.17l-4.584-4.586a2 2 0 01-.117-2.701l.117-.127a2 2 0 012.701-.117z\" fill=\"#6C92FA\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol